import { Grid, LinearProgress } from '@material-ui/core'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import changeLogo from '../../assets/images/altera-logo.png'
import ChallengeData from '../../components/ChallengeData'
import ChallengeRules from '../../components/ChallengeRules'
import FormNavigation from '../../components/FormNavigation'
import ImageUpload from '../../components/LogoUpload'
import SelectUnityToChallenges from '../../components/SelectUnityToChallenges'
import ToastMessages from '../../components/ToastMessages'
import Context from '../../context'
import { createChallenge, getUnitiesList } from '../../services/ClubeApi'
import ImageUploadToS3ge from '../../services/ImageUpload'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function ChallengeForm() {
  const { setUser, setAboutCurrentPage, setShowLoadingModal } = useContext(Context)
  const [isLoading, setIsLoading] = useState(false)
  const [fullPartnerList, setFullPartnerList] = useState([])
  const [selectedPartnerList, setSelectedPartnerList] = useState([])
  const [formObject, setFormObject] = useState({
    title: '',
    slug: '',
    description: '',
    startDate: moment(),
    endDate: moment(),
    type: '1',
    roles: '',
    reward: '',
    numberOfWinners: '1'
  })
  const [steps, setSteps] = useState({
    step: 1,
    maxStep: 4
  })

  const [newLogo, setNewLogo] = useState(changeLogo)
  const [iconLogo, setIconLogo] = useState(changeLogo)
  const [crop, setCrop] = useState({
    aspect: 78 / 45,
    unit: '%',
    width: 78,
    height: 45,
    x: 25,
    y: 10
  })
  const [logoToUpload, setLogoToUpload] = useState(null)

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Adicionar Desafio',
      buttons: [{ title: 'Voltar', pathname: '/challenge' }]
    })

    setIsLoading(true)
    getUnitiesList().then(r => {
      setFullPartnerList([...r])
      setIsLoading(false)
    })
  }, [])

  const handleContinue = async () => {
    if (steps.step < steps.maxStep) {
      setSteps({ ...steps, step: steps.step + 1 })
    }

    if (steps.step === steps.maxStep) {
      if (!logoToUpload) return
      if (!selectedPartnerList.length) return
      if (!formObject.title.trim()) return
      if (!formObject.slug.trim()) return
      if (!formObject.description.trim()) return
      if (!formObject.type) return
      if (!formObject.roles.trim()) return
      if (!formObject.reward.trim()) return
      if (!formObject.numberOfWinners) return
      if (!formObject.startDate.isValid()) return
      if (!formObject.endDate.isValid()) return
      if (formObject.startDate.isAfter(formObject.endDate, 'day')) return

      setIsLoading(true)
      setShowLoadingModal(true)

      let image
      try {
        image = await ImageUploadToS3ge(logoToUpload, 'desafio/')
      } catch {
        setShowLoadingModal(false)
        setIsLoading(false)
        return false
      }

      const data = {
        ...formObject,
        title: formObject.title.trim(),
        description: formObject.description.trim(),
        reward: formObject.reward.trim(),
        roles: formObject.roles.trim(),
        slug: formObject.slug.trim(),
        image,
        startDate: formObject.startDate.format('YYYY-MM-DD'),
        endDate: formObject.endDate.format('YYYY-MM-DD'),
        type: Number(formObject.type),
        numberOfWinners: Number(formObject.numberOfWinners),
        ChallengesPartnerList: selectedPartnerList.map(({ id: partnerUnitId }) => ({
          partnerUnitId
        }))
      }
      const createdChallenge = await createChallenge(data)
      setIsLoading(false)
      setShowLoadingModal(false)
      const toastMessage = data.id
        ? 'Desafio Atualizado com Sucesso.'
        : 'Desafio Criado com Sucesso.'
      if (createdChallenge.id) {
        history.push('/challenge', {
          showToast: true,
          toastMessage
        })
      }
    }
  }

  return (
    <div className="container-fluid">
      <Grid container xs={12} style={{ padding: 15 }}>
        <Grid item xs={12} justify="center">
          <ToastMessages />
          {isLoading ? (
            <LinearProgress marginTop="30px" />
          ) : (
            <Context.Provider
              value={{
                formObject,
                setFormObject,
                iconLogo,
                newLogo,
                setNewLogo,
                crop,
                setCrop,
                logoToUpload,
                setLogoToUpload,
                fullPartnerList,
                setFullPartnerList,
                selectedPartnerList,
                setSelectedPartnerList
              }}
            >
              <form
                className="clube-form"
                onSubmit={e => {
                  e.preventDefault()
                }}
              >
                {steps.step === 1 && <ChallengeData />}
                {steps.step === 2 && <ChallengeRules />}
                {steps.step === 3 && <SelectUnityToChallenges />}
                {steps.step === steps.maxStep && (
                  <div className="col-12">
                    <ImageUpload />
                  </div>
                )}
              </form>
            </Context.Provider>
          )}
        </Grid>
        <Grid item xs={12} justify="center">
          <div className="col-12">
            <button onClick={handleContinue} type="button" className="btn clube-button clube-blue">
              {steps.step !== steps.maxStep ? 'Continuar' : 'Salvar'}
            </button>
          </div>
        </Grid>
        <Grid item xs={12} justify="center">
          <Context.Provider value={{ steps, setSteps }}>
            <FormNavigation />
          </Context.Provider>
        </Grid>
      </Grid>
    </div>
  )
}

export default ChallengeForm
